import { activeRoomState } from "./states/active_room"

export function registerShortcut() {
  document.addEventListener('keyup', e => {
    if(e.altKey && e.ctrlKey && e.key === 'j') {
      localStorage.clear()
    } else if(e.altKey && e.ctrlKey && e.key === 's') {
      if(activeRoomState.mode === "grid") {
        activeRoomState.mode = 'speaker'
      } else if(activeRoomState.mode === 'speaker') {
        activeRoomState.mode = "grid"
      }
    }
  })
}
